import React, { useEffect, useState } from 'react';
import Scheduler from '../../components/Scheduler/index';
import { useSelector, useDispatch } from 'react-redux';
import DateRangeIcon from '@material-ui/icons/DateRange';
import PickupForm from './PickupForm';
import NotificationModal from './../../components/NotificationModal/index';
import PagePreloader from '../../components/PagePreloader/index';
import ConfirmationPopup from '../../components/ConfirmationPopup/index';
import { getPickupData, sendPickupData, setTimeProposalMode, proposeNewTime, toggleSuccessMessage } from '../../services/pickup_slot/actions';
import { cancelSchedule } from '../../services/create_schedule/actions';
import Button from '@material-ui/core/Button';
import { SuccessMessage, InfoMessage } from '../../components/Messages/index';
import ActionButton from '../../components/ActionButton/index';
import { getSchedulesJSON, hasEmptyDays } from '../../services/scheduler/utils'
import Moment from 'moment';
import schedulerConstants from '../../services/scheduler/constants';
import ContactForm from '../../components/ContactForm/index';
import ContactInfo from '../../components/ContactInfo/index';
import AddressModal from '../../components/AddressForm/AddressModal';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

const PickupSlot = (props) => {
    const eventId = props.match.params.guid;
    const dispatch = useDispatch();
    const schedule = useSelector(state => state.scheduler.schedule);
    const activeDay = useSelector(state => state.scheduler.activeDateSlot);
    const address = useSelector(state => state.scheduler.address);
    const [warningMessage, setWarningMessage] = useState('');
    const [cancelOpened, toggleCancelModalState] = useState(false);
    const [isSubmitted, setSubmitFlag] = useState(false);
    const [name, setName] = useState('');
    const {
        pickupSchedule,
        pending,
        buyerEmail,
        calendarContent,
        isSuccesMessageVisible: isModalOpened,
        specialInstructions,
        isTimeProposal,
        isBooked,
        eventName,
        bookedAt,
        buyerSchedules,
        buyerName: defaultBuyerName = '',
        buyerPhone: defaultBuyerPhone = '',
        buyerPhoneExtension: defaultBuyerPhoneExtension = '',
        sellerEmail,
        sellerName = '',
        sellerPhone = '',
        eventAddress,
        city,
        state,
        zipcode,
        sellerPhoneExtension
    } = useSelector(state => state.slotPickupData)
    const [buyerName, setBuyerName] = useState(defaultBuyerName);
    const [buyerPhone, setBuyerPhone] = useState(defaultBuyerPhone);
    const [buyerPhoneExtension, setBuyerPhoneExtension] = useState(defaultBuyerPhoneExtension);
    const onChange = (name) => (value) => {
        if (name == "buyerPhoneExtension") {
            value = value.replace(/[^0-9 ()+]/ig, '')
            setBuyerPhoneExtension(value)
        }
        else {
            setName('');
            value = value.replace(/[^A-Z a-z]/ig, '')
            setBuyerName(value)
        }
       
    };
   
    const hasSomeSlots =
        Object.values(schedule)
            .some(el => el.length);

    useEffect(() => {
        getPickupData(eventId)(dispatch);
    }, [eventId, dispatch]);

    useEffect(() => {
        if (hasEmptyDays(schedule)) {
            setWarningMessage('You have not selected time slots for some of your available dates.');
        } else {
            setWarningMessage('');
        }
    }, [schedule])

    const getContactInfo = () => {
        const info = {};
        if (buyerName) {
            info.buyerName = buyerName;
        }

        if (buyerPhone) {
            info.buyerPhone = buyerPhone;
        }

        if (buyerPhoneExtension) {
            info.buyerPhoneExtension = buyerPhoneExtension;
        }
        return info;
    }

    const handleSubmit = (formData) => {
        if (buyerName) {
            const scheduleJSON = getSchedulesJSON(schedule);
            const contactInfo = getContactInfo();
            if (isTimeProposal) {
                setSubmitFlag(true);
                if (hasEmptyDays(schedule)) return;
                proposeNewTime({
                    eventId,
                    buyerSchedules: scheduleJSON,
                    ...contactInfo,
                })(dispatch);
            } else {
                const { date, time } = scheduleJSON[0] || {};
                const requestData = {
                    datetime: (new Date(`${date} ${time[0].split(' ')[0]}`)).toISOString(),
                    buyerEmail: formData.email,
                    eventId,
                    schedules: getSchedulesJSON(schedule),
                    userSelectedDatetime: moment(date + " " + time[0].split(' ')[0]).format("MM/DD/YYYY HH:mm"),
                    ...contactInfo,
                }
                sendPickupData(requestData)(dispatch);
            }
        }
        else {
            setName("This field is required")
        }
    }

    const handleCancel = () => {
        cancelSchedule({ eventId: eventId, isSeller: false, isBuyer: true })(dispatch);
        toggleCancelModalState(false);
    };
    const cancelChanges = () => {
        window.location.reload();
    };
    const contactFormRenderer = () => {
        return (
            <ContactForm
                name={buyerName}
                setName={onChange(setBuyerName)}
                phone={buyerPhone}
                setPhone={setBuyerPhone}
                setExtension={onChange('buyerPhoneExtension')}
                extension={buyerPhoneExtension}
                error={name}
                buyerEmail={buyerEmail}
                isTimeProposal={isTimeProposal}
            />
        );
    };

    const renderSubmitForm = () => {
        return !buyerSchedules && !isBooked && (
            <>
                {contactFormRenderer()}
                <PickupForm
                    email={buyerEmail}
                    inactive={!hasSomeSlots}
                    onSubmit={handleSubmit}
                    submitTitle={isTimeProposal && 'Propose Appointment Date/Time'}
                    warningMessage={isSubmitted && isTimeProposal && warningMessage}
                />
            </>
        );
    }

    const renderPageActions = () => {
        if (isTimeProposal)
            return (
                <div className='page-actions'>
                    <ActionButton
                        onClick={() => {
                            cancelChanges()
                        }}
                        title='Cancel Changes'
                    />
                </div>
            ); 
        if (isBooked || buyerSchedules) return null;

        return (
            <div className='page-actions'>
                <ActionButton
                    onClick={() => {
                        dispatch(setTimeProposalMode(true))
                        dispatch({ type: schedulerConstants.RESET_SCHEDULER_STATE })
                    }}
                    title='Propose New Time'
                />
            </div>
        );
    }

    const renderLogger = () => {
        if (isBooked) {
            return (
                <InfoMessage
                    logger
                    title={(
                        <span>
                            Email Notification with {eventName} appointment details was sent to {buyerEmail} on {moment(moment.utc(bookedAt).toDate()).local().format('MM/DD/YYYY HH:mm A')}.
                        </span>
                    )}
                />
            );
        }

        return buyerSchedules && (
            <InfoMessage
                logger
                title={(
                    <span>
                        Email Notification with {eventName} appointment details was sent to {buyerEmail}.
                    </span>
                )}
            />
        );
    }

    if (pending) {
        return <PagePreloader />
    }

    const getCustomTimeslots = () => {
        if (isTimeProposal) return null;

        return pickupSchedule[activeDay] || [];
    }

    const getTitle = () => {
        if (isBooked) {
            return <span>{eventName} Appointment was successfully scheduled</span>
        }
        return isTimeProposal
            //? 'Propose Appointment Date/Time'
            ? 'Propose New Date/Time'
            : `${buyerSchedules ? 'Proposed' : 'Select'} Appointment Date/Time`
    };

    const getAddress = () => {
        var fullAddress = "";
        if (eventAddress !== undefined && eventAddress !== "" && eventAddress !== null) {
            fullAddress += eventAddress;
        }
        if (city !== undefined && city !== "" && city !== null) {
            if (fullAddress !== "") {
                fullAddress += ", " + city;
            }
            else {
                fullAddress += city;
            }
        }
        if (state !== undefined && state !== "" && state !== null) {
            if (fullAddress !== "") {
                fullAddress += ", " + state;
            }
            else {
                fullAddress += state;
            }
        }
        if (zipcode !== undefined && zipcode !== "" && zipcode !== null) {
            if (fullAddress !== "") {
                fullAddress += ", " + zipcode;
            }
            else {
                fullAddress += zipcode;
            }
        }

        return fullAddress;
    }
    const formatTimeSlot = (time) => {
        return moment('2018-01-01 ' + time.replace(" AM", "").replace(" PM", "")).format("hh:mm A")
    }

    const getLastMessage = (isWhat) => {
        var msg = "";
        //if (isWhat == "isBuyer") {
        //    //
        //    msg = 'Select dates highlighted to view available times. Click "CONFIRM APPOINTMENT" to confirm your selection.';  
        //}
        //else if (isWhat == "isSeller") {

        //}               
        //else if (isWhat == "isBooked") {
        //    msg = 'Select dates highlighted to view available times.';
        //}
        //else if (isWhat == "isBooked") {
        //    msg = 'Your event is scheduled for { Date and Time }.If you wish to cancel, please click on CANCEL EVENT';
        //}
        if (isBooked) {
            const scheduleJSON = getSchedulesJSON(pickupSchedule);
            msg = 'Your appointment is scheduled for ' + scheduleJSON[0].date + ' ' + formatTimeSlot(scheduleJSON[0].time[0]) + '. If you wish to cancel, please click on CANCEL APPOINTMENT.';
            return msg;
        }
        else if (isTimeProposal) {
            msg = 'Select dates highlighted to view available times. Click Propose New Date/Time to confirm your selection.';
            return msg;
        }
        msg = 'Select dates highlighted to view available times. Click "CONFIRM APPOINTMENT" to confirm your selection.';
        return msg;
    }
    return (
        <div className='page pickup-slot'>
            {buyerSchedules && !isBooked && (
                <SuccessMessage
                    title={
                        <span>{eventName} Appointment proposed Date/Time was successfully sent</span>
                    }
                />
            )}
            <div className='page-bar'>
                <h3 className='page-title'><DateRangeIcon />
                    {getTitle()}
                </h3>

                {renderPageActions()}
            </div>
            <div className="mb-10">{
                //    {isTimeProposal && <span>{getLastMessage("isSeller")}</span>}
                //    {!isTimeProposal && <span>{!isBooked && getLastMessage("isBuyer")}
                //        {isBooked && getLastMessage("isBooked")}</span>}                
            }
                <span>{getLastMessage("isSeller")}</span>
            </div>

            <Scheduler
                customTimeSlots={getCustomTimeslots()}
                hoursMultiselect={isTimeProposal}
                submitSenderer={renderSubmitForm}
                readOnly={buyerSchedules || isBooked}
                IsSeller={isTimeProposal}
                IsBuyer={true}
            />

            <div className='scheduler'>
                <div className='scheduler__left'>
                    {isBooked && (
                        <div style={{ marginBottom: '15px' }}>
                            <ActionButton onClick={() => toggleCancelModalState(true)} title='Cancel appointment' />
                        </div>
                    )}

                    {(address || specialInstructions) && (
                        <div><span className="address-speacial-instration-details">The seller provided the address and any special instructions for the appointment below. </span>
                            {(eventAddress) && (
                                <>
                                    <div className="address-speacial-instration-details-title">Appointment Address</div>
                                    <div>{getAddress()}</div>
                                    {
                                        //<AddressModal
                                        //    defaultAddress={address}
                                        //    readOnly
                                        ///>
                                    }
                                </>
                            )}
                            {specialInstructions && (
                                <>
                                    <div className="address-speacial-instration-details-title">Special Instructions</div>
                                    <div>{specialInstructions}</div>
                                </>
                            )}
                        </div>
                    )
                    }
                    <ContactInfo
                        title='Seller Contact Information'
                        email={sellerEmail}
                        name={sellerName}
                        phone={sellerPhone}
                        extension={sellerPhoneExtension}
                    />
                </div>
            </div>

            {renderLogger()}

            <NotificationModal
                titleRenderer={() => (
                    <SuccessMessage title='Appointment was successfully scheduled' />
                )}
                descriptionRenderer={() => (

                    <div className='notification-description'>

                        {
                            //                <Button
                            //                    endIcon={<DateRangeIcon />}
                            //                    onClick={() => {
                            //                        if (typeof window.navigator.msSaveBlob !== 'undefined') { // IE
                            //                            var blob = new Blob([calendarContent], { type: 'text/calendar' });
                            //                            window.navigator.msSaveBlob(blob, 'event.ics');
                            //                        } else {
                            //                            window.open("data:text/calendar;charset=utf8," + escape(calendarContent));
                            //                        }
                            //                    }}
                            //                    className='submit-button'
                            //                >
                            //                    Download iCalendar
                            //</Button>
                        }

                    </div>
                )}
                isOpened={isModalOpened}
                handleClose={() => dispatch(toggleSuccessMessage(false))}
            />

            <ConfirmationPopup
                title={'Confirm cancellation'}
                description={'Are you sure you want to cancel this appointment?'}
                handleConfirm={handleCancel}
                handleClose={() => toggleCancelModalState(false)}
                opened={cancelOpened}
            />
        </div>
    )
}

export default PickupSlot;